export const PENDING = 0;
export const REVIEW = 1;
export const INPROGRESS = 2;
export const REJECTED = 3;
export const ENDED = 4;
